import React from 'react'

export default function AnimeImage(props) {
    return (
        <div className='AnimeImage'>
            <img src={props.name} alt="" />
        </div>
    )
}
